<div class="spinner-centered">
  <svg viewBox="0 0 100 100" width="40" height="40" aria-hidden="true">
    <circle class="spinner-track" cx="50" cy="50" r="42" />
    <circle class="spinner-arc"   cx="50" cy="50" r="42" pathLength="100" />
  </svg>
</div>
